import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import * as React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  Routes as ReactRouterRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

const samplingMapping: Record<string, number> = {
  local: 1.0,
  staging: 1.0,
  production: 0.2,
};

const shouldInitSentry = window.config.SENTRY_DSN && window.config.SENTRY_ENVIRONMENT;

export const configTelemetry = (): void => {
  if (shouldInitSentry) {
    Sentry.init({
      dsn: window.config.SENTRY_DSN,
      environment: window.config.SENTRY_ENVIRONMENT,
      integrations: [
        new BrowserTracing({
          routingInstrumentation: Sentry.reactRouterV6Instrumentation(
            React.useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes as any,
          ),
        }),
      ],
      tracesSampleRate: samplingMapping[window.config.SENTRY_ENVIRONMENT] ?? 0,
    });
  }
};

export const Routes = shouldInitSentry ? Sentry.withSentryReactRouterV6Routing(ReactRouterRoutes) : ReactRouterRoutes;
